import React from "react";
import styles from "./styles.module.scss";
import PagePanel from "app/components/PagePanel";
import { cls } from "app/utils";
import DropdownButton from "app/components/DropdownButton";
import TabButton from "app/components/Button/TabButton";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "typedefs";
import GroupSettings from "./GroupSettings";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import GroupsModel from "app/models/GroupsModel";

interface IProps {
  groupData: GroupsModel;
}

const GroupTabsContainer = ({ groupData }: IProps) => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const location = useLocation();

  const { self } = useSelector((state: RootState) => state.user, shallowEqual);

  const onMembersClick = () => {
    if (!location.pathname.includes("members")) {
      history.push(`${window.location.pathname}/members`);
    }
  };

  const onTimelineClick = () => {
    if (location.pathname.includes("members")) {
      history.push(`/groups/${id}`);
    }
  };

  const canViewMembers =
    groupData?.permissions?.includes("view_members") ||
    groupData?.ownerId === self?.id;

  const headerDropdown = () => {
    return (
      <DropdownButton
        btnClassName={styles.dropdown_btn_className}
        btnContent={
          <i className="dropdown-toggle btn btn-outline-secondary ico ico-cog dark" />
        }
        hideButtonStyles
      >
        <GroupSettings groupData={groupData} />
      </DropdownButton>
    );
  };

  return (
    <div className={styles.container}>
      <PagePanel
        panelClassName={styles.panel}
        title={t("General")}
        titleStyles={cls("text-muted", styles.page_panel_title)}
        headerChildren={headerDropdown()}
      >
        <div className={styles.navbar_wrapper}>
          <TabButton
            label={t("Timeline")}
            icon={<i className={cls("tab-icon ico ico-feed-o")} />}
            isActive={!location.pathname.includes("members")}
            onClick={onTimelineClick}
            className={styles.mobile}
            data-testid="group-tab-timeline"
          />
          {canViewMembers && (
            <TabButton
              label={t("Members")}
              icon={<i className={cls("tab-icon ico ico-tspace-o")} />}
              isActive={location.pathname.includes("members")}
              onClick={onMembersClick}
              className={styles.mobile}
              data-testid="group-tab-members"
            />
          )}
        </div>
      </PagePanel>
    </div>
  );
};

export default GroupTabsContainer;
